module.exports = __webpack_public_path__ + "img/bg_1440.5967cbe5.png";